import { toast } from "react-toastify";
import { isFulfilled, isRejectedWithValue } from "@reduxjs/toolkit";
import { Middleware } from "redux";

export const notificationsMiddleware: Middleware = store => next => action => {
  if (isRejectedWithValue(action)) {
    switch (action.meta.arg.endpointName) {
    case "createOrg":
      if (action.payload.data.owner.email) {
        toast.error("An error occurred while trying to sign up - are you sure you have provided a valid email address?");
        return next(action);
      }
      toast.error("An error occurred while trying to sign up. Please try again later");
      return next(action);
    case "updateCharity":
      toast.error("An error occurred trying to update the charity. Please try again later");
      return next(action);
    case "updateCharityCollectionService":
      if (action.payload.data.phone) {
        toast.error("Oops, that does not appear to be a valid phone number");
        return next(action);
      }
      toast.error("An error occurred trying to update the charity. Please try again later");
      return next(action);
    case "updateCharityPostalService":
      toast.error("An error occurred trying to update the charity. Please try again later");
      return next(action);
    case "updateCharityDropoffService":
      toast.error("An error occurred trying to update the charity. Please try again later");
      return next(action);
    case "formUpdateCharity":
      toast.error("An error occurred trying to update the charity. Please try again later");
      return next(action);
    case "updateDroppoint":
      toast.error("An error occurred trying to update the drop point. Please try again later");
      return next(action);
    case "createItemQualityTier":
      toast.error("An error occurred trying to add this item. Please try again later");
      return next(action);
    case "updateItemQualityTier":
      toast.error("An error occurred trying to update this quality. Please try again later");
      return next(action);
    case "deleteItemQualityTier":
      toast.error("An error occurred trying to delete this item. Please try again later");
      return next(action);
    case "postMessage":
      toast.error("An error occurred trying to get in touch. Please try again later");
      return next(action);
    case "createItem":
      toast.error(action.payload.data.error || "An error occurred trying to delete this item. Please try again later");
      return next(action);
    case "loginWithEmailAndPassword":
      if (action.payload.data.error === "email-invalid") {
        toast.error("That email does not appear to be associated to any account");
        return next(action);
      }
      if (action.payload.data.error === "password-invalid") {
        toast.error("That password does not appear to match the email address you have provided");
        return next(action);
      }
      if (action.payload.data.error === "account-unverified") {
        toast.error("You must verify your account before logging in - please check your email inbox");
        return next(action);
      }
      toast.error("Oops, an unexpected error occurred. Please try again later");
      return next(action);
    case "loginWithTmpPass":
      if (action.payload.data.error === "id-invalid") {
        toast.error("That ID does not appear to be associated to any account");
        return next(action);
      }
      if (action.payload.data.error === "password-invalid") {
        toast.error("That password does not appear to match the email address you have provided");
        return next(action);
      }
      if (action.payload.data.error === "account-unverified") {
        toast.error("You must verify your account before logging in - please check your email inbox");
        return next(action);
      }
      toast.error("Oops, an unexpected error occurred. Please try again later");
      return next(action);
    case "sendPasswordResetEmail":
      if (action.payload.data.error === "email-invalid") {
        toast.error("That email does not appear to be associated to any account");
        return next(action);
      }
      toast.error("Oops, an unexpected error occurred. Please try again later");
      return next(action);
    case "updateUser":
      if (action.payload.data.error === "password-invalid") {
        toast.error("The password provided is incorrect");
        return next(action);
      }
      if (action.payload.data.error === "email-address-taken") {
        toast.error("That email address is already taken");
        return next(action);
      }
      toast.error("Oops, an unexpected error occurred. Please try again later");
      return next(action);
    case "requestLabelRefund":
      toast.error("Oops, an unexpected error occurred. Please try again later");
      return next(action);
    case "createOrder":
      toast.error("An error occurred while trying to create your order. Please try again later");
      return next(action);
    case "createPaymentIntent":
      toast.error("An error occurred while trying to create a payment. Please try again later");
      return next(action);
    }
  } else if (isFulfilled(action)) {
    switch (action.meta.arg.endpointName) {
    case "postMessage":
      toast.success("Message sent successfully");
      return next(action);
    case "updateUser":
      toast.success("User updated successfully");
      return next(action);
    case "sendPasswordResetEmail":
      toast.success("Request successful - please check your email inbox to reset your password");
      return next(action);
    }
  }

  next(action);
};
